import { FC, PropsWithChildren } from 'react';
import { IButton, IWithLink } from '@belong/types';
import { Button } from '../../../actions/Button';
import { useFormButtonState } from './useFormButtonState';

export const FormButton: FC<PropsWithChildren<Omit<IButton, 'isLoading'> & IWithLink>> = ({
  variant = 'primary',
  iconOnly,
  children,
  ...otherProps
}) => {
  const { isLoading, isInlineSpinnerLoading } = useFormButtonState({ variant, iconOnly });
  return (
    <Button
      variant={variant}
      iconOnly={iconOnly}
      {...otherProps}
      isLoading={isLoading}
      isInlineSpinnerLoading={isInlineSpinnerLoading}
    >
      {children}
    </Button>
  );
};

FormButton.displayName = 'FormButton';
